import { useEffect, useState } from "react"

export default function useCookieScript() {
  const [loading, setLoading] = useState(true)
  const [categories, setCategories] = useState(null)
  const [newConsent, setNewConsent] = useState(false)

  const onReady = () => {
    setLoading(false)
    setCategories(window.CookieScript.instance.currentState()?.categories ?? [])
  }

  const onChange = () => {
    setCategories(window.CookieScript.instance.currentState()?.categories ?? [])
    setNewConsent(true)
  }

  useEffect(() => {
    window.addEventListener("CookieScriptLoaded", onReady)
    window.addEventListener("CookieScriptAcceptAll", onChange)
    window.addEventListener("CookieScriptAccept", onChange)
    return () => {
      window.removeEventListener("CookieScriptLoaded", onReady)
      window.removeEventListener("CookieScriptAcceptAll", onChange)
      window.removeEventListener("CookieScriptAccept", onChange)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    loading,
    categories,
    newConsent
  }
}
